// Landing page for the password-reset email link.
// Supabase redirects here with a session already attached (via
// `detectSessionInUrl: true`) so the user can set a new password directly.

import { useState } from 'react';
import { supabase } from '../lib/supabase.js';

export function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      if (password.length < 8) throw new Error('Password must be at least 8 characters.');
      if (password !== confirm) throw new Error("Passwords don't match.");
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setOk(true);
    } catch (err) {
      setError(err?.message || String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <form onSubmit={submit} className="auth-card">
        <h1 className="auth-title">Set a new password</h1>
        <p className="auth-sub">Pick something strong. You'll be signed in automatically.</p>

        {ok ? (
          <div className="auth-info">
            All set. <a href="/" style={{ color: 'var(--accent-hi)' }}>Open the app →</a>
          </div>
        ) : (
          <>
            <div className="auth-field">
              <input
                className="input"
                type="password"
                autoComplete="new-password"
                placeholder="New password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                minLength={8}
              />
            </div>
            <div className="auth-field">
              <input
                className="input"
                type="password"
                autoComplete="new-password"
                placeholder="Confirm new password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
                minLength={8}
              />
            </div>
            {error && <div className="auth-error">{error}</div>}
            <button className="auth-submit" type="submit" disabled={busy}>
              {busy ? 'Saving…' : 'Save password'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
